export const historyQuestions = [
  {
    id: 'history-001',
    category: 'History',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'The Great Fire of London occurred in which year?',
    options: ['1066', '1492', '1666', '1776'],
    answer: '1666',
    insight: 'The fire destroyed much of medieval London.',
    tags: ['london', 'fire', 'england'],
    points: 10,
  },
  {
    id: 'history-002',
    category: 'History',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'Which country gifted the Statue of Liberty to the United States?',
    options: ['France', 'Spain', 'Italy', 'Germany'],
    answer: 'France',
    insight: 'France gifted the statue in 1886.',
    tags: ['statue of liberty', 'france', 'usa'],
    points: 10,
  },
  {
    id: 'history-003',
    category: 'History',
    difficulty: 'Easy',
    type: 'true/false',
    question: 'The Titanic sank in 1912.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'The Titanic sank during its maiden voyage in April 1912.',
    tags: ['titanic', 'ships', '1900s'],
    points: 10,
  },
  {
    id: 'history-004',
    category: 'History',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'In which country did the ancient Olympic Games originate?',
    options: ['Greece', 'Italy', 'Egypt', 'China'],
    answer: 'Greece',
    insight: 'The ancient games began in Olympia, Greece.',
    tags: ['olympics', 'greece', 'ancient history'],
    points: 20,
  },
  {
    id: 'history-005',
    category: 'History',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which civilization built Machu Picchu?',
    options: ['Inca', 'Maya', 'Aztec', 'Roman'],
    answer: 'Inca',
    insight: 'Machu Picchu was built by the Inca in the Andes.',
    tags: ['inca', 'machu picchu', 'south america'],
    points: 20,
  },
  {
    id: 'history-006',
    category: 'History',
    difficulty: 'Medium',
    type: 'true/false',
    question: 'Paper was first developed in ancient China.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Paper was developed in China during the Han Dynasty.',
    tags: ['paper', 'china', 'inventions'],
    points: 20,
  },
  {
    id: 'history-007',
    category: 'History',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Who was the first president of the United States?',
    options: ['George Washington', 'Thomas Jefferson', 'John Adams', 'James Madison'],
    answer: 'George Washington',
    insight: 'George Washington served as the first U.S. president.',
    tags: ['presidents', 'usa', 'washington'],
    points: 20,
  },
  {
    id: 'history-008',
    category: 'History',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'The Magna Carta was signed in which year?',
    options: ['1066', '1215', '1492', '1649'],
    answer: '1215',
    insight: 'The Magna Carta limited royal power in England.',
    tags: ['magna carta', 'england', 'law'],
    points: 30,
  },
  {
    id: 'history-009',
    category: 'History',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which empire was ruled by Suleiman the Magnificent?',
    options: ['Ottoman Empire', 'Roman Empire', 'Mongol Empire', 'Byzantine Empire'],
    answer: 'Ottoman Empire',
    insight: 'Suleiman ruled the Ottoman Empire in the 1500s.',
    tags: ['ottoman', 'suleiman', 'empires'],
    points: 30,
  },
  {
    id: 'history-010',
    category: 'History',
    difficulty: 'Hard',
    type: 'true/false',
    question: 'The Rosetta Stone helped scholars read Egyptian hieroglyphs.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Its repeated text helped decode hieroglyphic writing.',
    tags: ['egypt', 'rosetta stone', 'language'],
    points: 30,
  },
];
